import axiosInstance from "@/lib/axios";

export const storyService = {
  // Récupérer la liste paginée des stories (modération)
  getStories: async (params = {}) => {
    const response = await axiosInstance.get('/api/v1/admin/stories', { params });
    return response.data;
  },

  // Créer une story admin (toujours affichée en premier côté mobile)
  createStory: async (data) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key]);
      }
    });

    const response = await axiosInstance.post('/api/v1/admin/stories', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Supprimer une story (modération, avant même son expiration à 24h)
  deleteStory: async (id) => {
    const response = await axiosInstance.delete(`/api/v1/admin/stories/${id}`);
    return response.data;
  },

  // Nombre de vues + liste des spectateurs — réservé à l'admin créateur de la story
  getViewers: async (id) => {
    const response = await axiosInstance.get(`/api/v1/admin/stories/${id}/viewers`);
    return response.data;
  },
};
